import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import ImageIcon from '@material-ui/icons/Image';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { parseDateToStringFormat } from '../../utils/dateUtils';
import { SERVER_ADDR, USER_FILES_FOLDER } from '../../constants';

const CustomTableCell = withStyles(theme => ({
  head: {
    fontSize: 15,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    overflowX: 'auto',
  },
  table: {
    minWidth: 200,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  pointer: {
    cursor: 'pointer'
  }
});

function FriendList(props) {
  const {
    classes,
    handleChangeRowsPerPage,
    handleChangePage,
    rowsPerPage,
    page,
    totalRecords,
    list
  } = props;

  return (
    <React.Fragment>
      <Typography variant="h5">User Connections</Typography>
      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <CustomTableCell>Users</CustomTableCell>
              <CustomTableCell>Friends On</CustomTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {list.map(row => {
              const user = row.userDetails || {};

              return (
                <TableRow className={classes.row} key={row.id}>
                  <CustomTableCell component="th" scope="row">
                    <List>
                      <ListItem>
                        {
                          user.image ?
                            <Avatar
                              alt="Profile Pic"
                              src={`${SERVER_ADDR}public/assets/${USER_FILES_FOLDER}/${user.image}`}
                              className={classes.avatar}
                            /> : <ImageIcon />
                        }
                        <ListItemText primary={`${user.firstName} ${user.lastName}`} secondary={user.email} />
                      </ListItem>
                    </List>
                  </CustomTableCell>
                  <CustomTableCell>{parseDateToStringFormat(row.createdAt)}</CustomTableCell>
                </TableRow>
              );
            })}
            {
              list.length < 1 &&
              <TableRow className={classes.row}>
                No Record Found
              </TableRow>
            }
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={totalRecords}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'Previous Page',
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page',
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </React.Fragment>
  );
}

FriendList.propTypes = {
  classes: PropTypes.object.isRequired,
  list: PropTypes.array,
  updateDakk: PropTypes.func,
  openView: PropTypes.func
};

FriendList.defaultProps = {
  list: []
};

export default withStyles(styles)(FriendList);